import { Select } from "antd"
import React from "react"

const SelectLocalRoaming = ({ value, onChange, disabled, style={ height: "36px"} }) => {
  return (
    <Select
      placeholder="Local/Roaming"
      title="Local/Roaming"
      allowClear
      value={value}
      onChange={onChange}
      disabled = {disabled}
      style={ style}
    >   
      <Select.Option value="1">Local</Select.Option>
      <Select.Option value="2">Roaming</Select.Option>

    </Select>
  )
}

export default SelectLocalRoaming
